export interface Validator {
  typeIsString(value): Validator
  typeIsStringNumberOrDate(value): Validator
  typeIsStringNumberBoolOrDate(value): Validator
  sameType(first, second): Validator
  typeIsStringNumberOrDateForAll(values): Validator
  validFieldName(field): Validator
  isInstanceOfSameClass(obj): Validator
  arityIsOne(args): Validator
  arityIsTwo(args): Validator
  arityIsThree(args): Validator
  arityIsAtLeastTwo(args): Validator
  validateAndAggregate(): [string[], boolean]
}
